import { BUSINESS_NAME, PHONE_DISPLAY, PHONE_TEL, EMAIL, SERVICE_AREAS } from "@/config/site";

const LOCAL_BUSINESS_BASE = {
  "@context": "https://schema.org",
  "@type": ["TowingService", "AutomotiveBusiness", "LocalBusiness"],
  name: BUSINESS_NAME,
  telephone: `+1-${PHONE_TEL.replace("+1", "")}`,
  email: EMAIL,
  image: "/images/job-1.webp",
  priceRange: "$$",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Kirkland",
    addressRegion: "WA",
    addressCountry: "US",
  },
  areaServed: SERVICE_AREAS.map((c) => `${c.name}, WA`),
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    opens: "00:00",
    closes: "23:59",
  },
  openingHours: "Mo-Su 00:00-23:59",
};

export function localBusinessSchema({ url } = {}) {
  return {
    ...LOCAL_BUSINESS_BASE,
    ...(url ? { url } : {}),
  };
}

export function serviceSchema({ service, url }) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: service.title,
    name: service.title,
    description: service.metaDesc,
    provider: LOCAL_BUSINESS_BASE,
    areaServed: SERVICE_AREAS.map((c) => ({ "@type": "City", name: c.name })),
    ...(url ? { url } : {}),
  };
}

export function citySchema({ city, url }) {
  return {
    ...LOCAL_BUSINESS_BASE,
    name: `${BUSINESS_NAME} — Tow Truck in ${city.name}, WA`,
    description: city.metaDesc,
    areaServed: {
      "@type": "City",
      name: `${city.name}, WA`,
    },
    ...(url ? { url } : {}),
  };
}

export function faqSchema(faqs = []) {
  if (!faqs.length) return null;
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}

export function breadcrumbSchema(items = []) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: it.url,
    })),
  };
}
